


























































import { mapGetters, mapState } from 'vuex'
import { mapDeps } from '~/plugins/dependency-container/utils'
import StatsService from '~/services/stats/StatsService'
import { removeHttpFromUrl } from '~/utils/http'
import SellerInfoIcon from '~/components/car/classifieds/view/partials/seller/dealer/SellerInfoIcon.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    SellerInfoIcon
  },
  props: {
    email: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: false,
      default: null
    },
    internalPage: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: false,
      default: null
    },
    website: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: false,
      default: null
    },
    socials: {
      validator: prop => typeof prop === 'object' || prop === null,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapDeps({ statsService: StatsService }),
    ...mapState({
      classifiedId: state => state.classifieds.view.classified.id
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      isWantedPartsClassified: 'isWantedPartsClassified'
    }),
    formatedInternalPage() {
      if (this.isWantedPartsClassified) {
        return this.$t('dealer_classifieds')
      }
      return removeHttpFromUrl(this.internalPage)
    },
    formatedWebsite() {
      return removeHttpFromUrl(this.website)
    }
  },
  methods: {
    recordEmailLinkClick() {
      const { statsService } = this
      statsService.record('events.clsfds.email_link_click', [this.classifiedId])
    },
    recordExternalLinkClickStat() {
      const { statsService } = this
      statsService.record('events.clsfds.external_link_click', [
        this.classifiedId
      ])
    }
  }
})
